import { controls } from "../../controls";

const rp606 = {
  label: "CCB 12-Part A-Non Agri",
  pageLabel: "CCB 12-Part A-Non Agri",
  starting: true,
  url: "rp606",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "STATEMENT CCB-12\nA. Defaults in excess of Rs. 50,000/- (Borrower-wise details to be provided)",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Name of the Branch",
        accessor: "branchname",              
        width: 145,
        rwidth: 90
      },

      {
        Header: "Name of the Society",
        accessor: "society_name",              
        width: 300,
        rwidth: 180
      },

      {
        Header: "Type of loan defaulted (including CC accounts)",
        accessor: "loan_type",              
        width: 220,
        rwidth: 150
      },
      
      {
        Header:"Date of of default",
        accessor: "default_date",        
        type:"date",      
        width: 125,
        rwidth: 70
      },

      {
        Header: "Amount defaulted",
        accessor: "default_amt",  
        type:"currency",            
        width: 125,
        rwidth: 70
      },

      {
        Header:"When cleared subsequently",
        accessor: "subsequently",              
        width: 125,
        rwidth: 70
      },     

      {
        Header: "Remarks",
        accessor: "remarks",              
        width: 100,
        rwidth:50
      }
    ]
  }
};

export default rp606;